"use client"

import { defineSlotRecipe } from "@chakra-ui/react"
import { tableAnatomy } from "@chakra-ui/react/anatomy"

const table = defineSlotRecipe({
  className: "hydrologiq-table",
  slots: tableAnatomy.keys(),

  variants: {
    variant: {
      outline: {
        root: {
          mt: "12px",
          borderRadius: "{radii.card}",
          boxShadow: "{shadows.card}",
          overflow: "hidden",
          border: "1.5px solid {colors.divider_subtle}",
        },
        columnHeader: {
          borderBottomWidth: "none",
          textTransform: "uppercase",
          bg: "table_header",
          paddingBlock: "0px !important",
          letterSpacing: "0.05em",
        },
        row: {
          bg: "card",
          transition: "background 0.12s",
          "&:last-child > td": {
            borderBottom: "none",
          },
        },
      },

      hydrologiq: {
        root: {
          borderCollapse: "separate",
          borderSpacing: "0px 0px",
          tableLayout: "auto",
          width: "100%",
          borderRadius: "{radii.card}",
          boxShadow: "{shadows.card}",
          overflow: "hidden",
          border: "0.0625rem solid {colors.divider_subtle}",
        },
        row: {
          bg: "card",
          minHeight: "2.5rem",
          transition: "background 0.12s",
          "&:last-child > td": {
            borderBottom: "none",
          },
        },
        cell: {
          minHeight: "2.5rem",
          paddingBlock: "0.55rem !important",
          paddingInline: "0.625rem !important",
          borderBottom: "0.0625rem solid {colors.divider_subtle}",
          verticalAlign: "middle",
          fontSize: "0.875rem",
          lineHeight: "1.3",
        },
        columnHeader: {
          minHeight: "3.5rem",
          fontWeight: "medium",
          textAlign: "start",
          borderBottomWidth: "none",
          textTransform: "uppercase",
          bg: "table_header",
          paddingBlock: "1.25rem !important",
          paddingInline: "0.625rem !important",
          letterSpacing: "0.03em",
          verticalAlign: "middle",
          wordBreak: "normal",
          overflowWrap: "normal",
          hyphens: "none",
          fontSize: "0.75rem !important",
          lineHeight: "1.15",
          "& >*": {
            fontWeight: "medium",
          },
        },
      },
    },
    size: {
      md: {
        root: {
          fontSize: "0.75rem",
          color: "primary",
        },
        columnHeader: {
          letterSpacing: "0.03em",
          fontSize: "0.6875rem",
          fontWeight: "medium",
          color: "primary",
        },
      },
    },
  },
})

export default table
